const leaflets = {
    "costantiello": {
        "config": {
            "primary-color": "#4d79b5",
            "secondary-color": "#f37032",
            "tertiary-color": "#98bf5d",
            "hover-color": "rgba(220, 35, 17, 0.5)",
            "clientIcon": require("assets/images/Costantiello-icon.png"),
            "serverPath": "costantiello.volantinointerattivo.net/",
            "pdfPath": "/media/pdf/1_costantiello.pdf",
            "shareFlyerTitle": "Dai uno sguardo al nuovo volantino interattivo di Costantiello!",
            "shareFlyerURL": "https://costantiello.volantinointerattivo.net",
            "shareProductSentence": "Guarda questa fantastica offerta!",
            "ogTitleMeta": "Volantino Interattivo di Costantiello",
            "ogDescriptionMeta": "Dai uno sguardo al nostro nuovo volantino.",
            "ogImageMeta": "https://costantiello.volantinointerattivo.net/media/images/Costantiello_fb_01.png",
            "filterBrand": 0,
            "filterUnderprice": 0,
            "brandImage": "",
            "underPriceImage": "",
            "ga_active": false,
            "ga_tracking_id": "UA-152069090-12",
            "release_id": "1",
            "send_grocery_list_to_market": true,
            "grocery_list_min_value": 10,
            "client_id": 10,
            "signboard_id": 11,
            "has_pages": true,
            "hide_grocery_list": false,
            "hide_searchbar": false,
            "line_through": false,
            "category_banner": ""
        },
        "leaflet": {
            "name": "Supermercati Constantiello",
            "code" : "456",
            "id_campaign": "456",
            "index": {
                "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/pages/indice_costantiello-01_t0mKcKv.png",
                "links": [
                    {
                        "page": 2,
                        "blueprint": {
                            "top": 26.485373323476608,
                            "left": 12.999700777977262,
                            "width": 73.74625972471574,
                            "height": 5.108247967050375
                        }
                    },
                    {
                        "page": 3,
                        "blueprint": {
                            "top": 36.18016686028092,
                            "left": 12.872531418312391,
                            "width": 74.25493716337523,
                            "height": 5.108247967050375
                        }
                    },
                    {
                        "page": 4,
                        "blueprint": {
                            "top": 46.23402682437427,
                            "left": 13.381208856971877,
                            "width": 74.25493716337523,
                            "height": 5.108247967050375
                        }
                    }
                ]
            },
            "categories": [
                {
                    "category_name": "Alimentari",
                    "subcategories": [
                        "Dispensa",
                        "Colazione",
                        "Snack Dolci",
                        "Pasta",
                        "Rossi",
                        "Olio"
                    ]
                },
                {
                    "category_name": "Igiene Casa",
                    "subcategories": [
                        "Extra",
                        "Superfici",
                        "Bucato",
                        "Pavimenti"
                    ]
                },
                {
                    "category_name": "Gastronomia",
                    "subcategories": [
                        "Formaggi",
                        "Salumi"
                    ]
                },
                {
                    "category_name": "No Food",
                    "subcategories": [
                        "Home"
                    ]
                },
                {
                    "category_name": "Bevande",
                    "subcategories": [
                        "Vini e Spumanti",
                        "Bibite"
                    ]
                },
                {
                    "category_name": "Self Service",
                    "subcategories": [
                        "Vegetali"
                    ]
                },
                {
                    "category_name": "Surgelati",
                    "subcategories": [
                        "Ittico",
                        "Dolci"
                    ]
                },
                {
                    "category_name": "Igiene Persona",
                    "subcategories": [
                        "Corpo",
                        "Orale",
                        "Intima"
                    ]
                },
                {
                    "category_name": "Prima infanzia",
                    "subcategories": [
                        "Puericultura"
                    ]
                },
                {
                    "category_name": "Piccoli elettrodomestici",
                    "subcategories": [
                        "Preparazione cibo"
                    ]
                }
            ],
            "pages": [
                {
                    "number": 1,
                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/pages/page_1_6kZMaSh.jpg",
                    "products": [
                        {
                            "item_id": "cstm53008601",
                            "field1": "Lavazza",
                            "field2": "Qualità Rossa",
                            "field3": "gr.250 x 4",
                            "field4": "",
                            "description": "Lavazza Qualità Rossa gr.250 x 4",
                            "grammage": 1000,
                            "price": "6.49",
                            "price_label": "€ 6,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 23.58617558630893,
                                "left": 0.0,
                                "width": 57.84231805929919,
                                "height": 21.201413427561832
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/Lavazza-QualitC3A0-Rossa-CaffC3A8-Macinato---4-x-250-g-4.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_1mr9LlZ_1J6t6Tv.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/piflsq6NHY/video/Lavazza_Coffee_Hacks_-_Moka.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm48826796",
                            "field1": "Finish",
                            "field2": "Powerball all in 1",
                            "field3": "",
                            "field4": "100pz",
                            "description": "Finish Powerball all in 1 100pz",
                            "grammage": null,
                            "price": "8.99",
                            "price_label": "€ 8,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 23.76587010562609,
                                "left": 57.92228212039532,
                                "width": 42.07771787960467,
                                "height": 40.96781055244953
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/image_2wjuqqv.png",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_OnWjWuC_eVvr3eM.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm35880085",
                            "field1": "Barilla",
                            "field2": "Biscocrema Pan di stelle",
                            "field3": "",
                            "field4": "gr. 168",
                            "description": "Barilla Biscocrema Pan di stelle gr. 168",
                            "grammage": 168,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 44.70028160607532,
                                "left": 0.508535489667565,
                                "width": 54.7911051212938,
                                "height": 20.12324631165887
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/barilla_IEVWhrX.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_7DHNhwh_Yg3yp2G.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.pandistelle.it/prodotti/biscocrema"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm32044931",
                            "field1": "grana padano dop",
                            "field2": "",
                            "field3": "11 mesi min.",
                            "field4": "",
                            "description": "grana padano dop 11 mesi min.",
                            "grammage": null,
                            "price": "8.49",
                            "price_label": "€ 8,49 al Kg",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "kg.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 58.716454112813864,
                                "left": 0.0,
                                "width": 61.65633423180592,
                                "height": 35.75666949225186
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_AK2Jr3r_5YbdkHe.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "hat-chef",
                                    "title": "Crema di Grana Padano",
                                    "data": {
                                        "ingredients": "100 gr di Grana Padano grattugiato, 200 ml di Latte, 20 gr di Burro, 20 gr di Farina 00",
                                        "recipe": "Per preparare la Crema di Grana Padano iniziate facendo cuocere il latte, ma senza portalo ad ebollizione. Nel frattempo in una ciotola versate il burro precedentemente sciolto. Aggiungete anche la farina a pioggia, mescolando continuamente con una frusta. A questo punto aggiungete anche il latte caldo a filo, senza mai smettere di mescolare.\nMettete il composto sul fuoco a fiamma bassa e continuate a mescolare fino a quando non si sarà addensato. Spegnete il fuoco e aggiungete il grana grattugiato, sempre mescolando con le fruste fino ad ottenere un composto omogeneo. Ecco che la Crema di Grana Padano è pronta!\n(fonte: clubdellericette.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/piflsq6NHY/images/crema_grana_padano.png"
                                        ]
                                    }
                                },
                                {
                                    "type": "info",
                                    "title": "Curiosità",
                                    "data": {
                                        "titolo": "Storia del Grana Padano",
                                        "testo": "E' il 1135 e i monaci cistercensi dell'abbazia di Chiaravalle trovano nella bonifica delle terre della pianura del Po una grande opportunità per favorire l'espandersi dell'agricoltura e degli allevamenti e aumentare così la produzione di buon cibo. La conseguenza di questa enorme opera porta a una grande disponibilità di latte, di molto superiore al fabbisogno della comunità religiosa e della popolazione dei dintorni. È un peccato sprecare uno degli alimenti tra i più nutrienti e disponibili nella dieta medievale. Emerge così l'esigenza di trovare un modo per riuscire a conservarlo a lungo.\nCome nasce\nProbabilmente a seguito di qualche colta riflessione e un po' di esperimenti, matura l'idea di cuocere a lungo il latte, aggiungervi il caglio e in seguito sottoporlo a salatura.\n\nNasce così un formaggio a pasta dura, che sembra acquistare sempre più sapore via via che passa il tempo e la cui stagionatura permette di conservare inalterati i principi nutritivi della sua preziosa materia prima, il latte.\nLa fama del \"grana\" prodotto\nnella zona padana si consolida nel tempo e ben presto esso diventa un formaggio pregiato protagonista dei banchetti rinascimentali di principi e duchi.\n\nTra le testimonianze documentate, se ne trova riferimento in una missiva di Isabella d'Este, consorte di Francesco II Gonzaga e marchesa di Mantova, che invia il rinomato formaggio in regalo ai suoi familiari, signori del ducato di Ferrara.\nGrazie alle sue ricche proprietà nutritive\nalla sua lunga conservazione e alla non alterabilità delle sue caratteristiche alimentari e di gusto, il \"formai de grana\" diventa un importante alimento della gente di campagna, soprattutto durante le terribili carestie.\n\nIl \"grana padano\" diventa così espressione di un'intera cultura sociale ed economica, trasversale alle sue classi, apprezzato sia dai ricchi e dai nobili, avvezzi ormai a una cucina piuttosto elaborata e raffinata, sia dai poveri le cui ricette quotidiane sono molto più semplici, ma tradizionali.",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/piflsq6NHY/images/00b-gp-mipresento-storiaslot-6-5002.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm80819309",
                            "field1": "Regina",
                            "field2": "tovaglioli",
                            "field3": "x250",
                            "field4": "",
                            "description": "Regina tovaglioli x250",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 64.28698421164584,
                                "left": 42.920485175202145,
                                "width": 57.07951482479784,
                                "height": 26.592249007076656
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/regina_7QP4FUV.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_7rMMII2_dJPJSn8.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 2,
                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/pages/page_2_iwuBCCV.jpg",
                    "products": [
                        {
                            "item_id": "cstm33526902",
                            "field1": "Crich",
                            "field2": "Biscotti classici/cacao",
                            "field3": "",
                            "field4": "gr.500",
                            "description": "Crich Biscotti classici/cacao gr.500",
                            "grammage": 500,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classici",
                                "Cacao"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 4.08932024039698,
                                "left": 4.398921832884091,
                                "width": 30.50853548966757,
                                "height": 19.404468234390226
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_tuYpgH6_dr6yAqW.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm94597209",
                            "field1": "Vincenzovo",
                            "field2": "Savoiardi",
                            "field3": "",
                            "field4": "gr.300",
                            "description": "Vincenzovo Savoiardi gr.300",
                            "grammage": 300,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 3.8197784614212393,
                                "left": 34.40251572327043,
                                "width": 31.271338724168913,
                                "height": 19.763857273024545
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_5ZGcrMT_djhIdV0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "hat-chef",
                                    "title": "Tiramisu di Matilde Vicenzi",
                                    "data": {
                                        "ingredients": "300 g di savoiardi Vicenzovo, 300 g di mascarpone, 3 uova, 70 g di zucchero, 1 tazza e ½ di caffè forte, 20 g di cacao, 2 cucchiai di Marsala dolce",
                                        "recipe": "rendete le uova e separate i tuorli dagli albumi, quindi lavorate i tuorli con lo zucchero fino a ottenere una crema.\nAggiungete il mascarpone e mescolate bene, poi incorporate gli albumi già montati a neve ferma.\nBagnate velocemente i savoiardi Vicenzovo nel caffè, al quale avrete aggiunto il Marsala dolce, e adagiatene un primo strato in un vassoio, ricoprendolo con metà della crema al mascarpone.\nContinuate, alternando strati di crema a strati di savoiardi. Spolverizzate il dolce con il cacao e servite freddo.",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/piflsq6NHY/images/tiramis%C3%B9-ricotta-leggero.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "cstm95600384",
                            "field1": "Granarolo",
                            "field2": "Latte accadì uht",
                            "field3": "PS/S ",
                            "field4": "lt.1",
                            "description": "Granarolo Latte accadì uht PS/S  lt.1",
                            "grammage": 1000,
                            "price": "0.95",
                            "price_label": "€ 0,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "1% di grassi",
                                "Senza grassi"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 4.269014759714141,
                                "left": 65.4231805929919,
                                "width": 30.254267744833783,
                                "height": 18.865384676438744
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_jrKZNm7_v7ZXBAJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm27302707",
                            "field1": "Ora si",
                            "field2": "LAtte di riso e di soia",
                            "field3": "",
                            "field4": "lt.1",
                            "description": "Ora si LAtte di riso e di soia lt.1",
                            "grammage": 1000,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Naturalmente buono",
                                "Semplicemente gustoso"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 23.047092028357444,
                                "left": 4.195417789757411,
                                "width": 30.50853548966757,
                                "height": 16.798897704291395
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_JO8p0JF_BMcw1Ik.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm35650448",
                            "field1": "Gandola",
                            "field2": "Crema spalmabile cacao",
                            "field3": "",
                            "field4": "gr.750",
                            "description": "Gandola Crema spalmabile cacao gr.750",
                            "grammage": 750,
                            "price": "2.19",
                            "price_label": "€ 2,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 23.226786547674607,
                                "left": 34.199011680143755,
                                "width": 31.525606469002692,
                                "height": 16.798897704291395
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_P8DnCfx_eKU4EQO.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm09276750",
                            "field1": "Saiwa Mikado",
                            "field2": "",
                            "field3": "latte",
                            "field4": "gr.39",
                            "description": "Saiwa Mikado latte gr.39",
                            "grammage": 39,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 23.136939288016027,
                                "left": 65.3468104222821,
                                "width": 29.618598382749333,
                                "height": 16.798897704291395
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_W0MV4zc_MhLO9NW.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm38998708",
                            "field1": "de cecco",
                            "field2": "Pasta formati normali",
                            "field3": "Vari tipi",
                            "field4": "gr.500",
                            "description": "de cecco Pasta formati normali Vari tipi gr.500",
                            "grammage": 500,
                            "price": "0.85",
                            "price_label": "€ 0,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Rigatoni",
                                "Spaghetti"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 42.49775381850853,
                                "left": 4.676774483378261,
                                "width": 37.631626235399814,
                                "height": 16.26235399820305
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_BzlQwlX_Ymu4ay9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.dececco.com/it_it/"
                                }
                            ]
                        },
                        {
                            "item_id": "cstm69518342",
                            "field1": "De cecco",
                            "field2": "passata",
                            "field3": "",
                            "field4": "ml.700",
                            "description": "De cecco passata ml.700",
                            "grammage": 700,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Rossi",
                            "blueprint": {
                                "top": 42.49775381850853,
                                "left": 41.9269991015274,
                                "width": 28.350853548966754,
                                "height": 16.17250673854447
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_8cWY0By_NRv1n4W.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm68928830",
                            "field1": "De cecco",
                            "field2": "olio extravergine d'oliva",
                            "field3": "",
                            "field4": "lt.1",
                            "description": "De cecco olio extravergine d'oliva lt.1",
                            "grammage": 1000,
                            "price": "3.59",
                            "price_label": "€ 3,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Olio",
                            "blueprint": {
                                "top": 42.58760107816711,
                                "left": 70.27785265049414,
                                "width": 25.426774483378253,
                                "height": 16.17250673854447
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_E2AAj6X_HqflwLJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm82358001",
                            "field1": "Scotti",
                            "field2": "Riso parboiled",
                            "field3": "",
                            "field4": "kg.1",
                            "description": "Scotti Riso parboiled kg.1",
                            "grammage": 1000,
                            "price": "1.09",
                            "price_label": "€ 1,09",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 58.93980233602874,
                                "left": 4.041105121293804,
                                "width": 30.893530997304577,
                                "height": 17.430368373764598
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_7jyQjuQ_FS7suTd.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm22307726",
                            "field1": "Ponti",
                            "field2": "Peperlizia Insalata per riso",
                            "field3": "vari gusti",
                            "field4": "gr. 370",
                            "description": "Ponti Peperlizia Insalata per riso vari gusti gr. 370",
                            "grammage": 370,
                            "price": "1.45",
                            "price_label": "€ 1,45",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Light senza olio",
                                "Funghi porcini"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 58.76010781671158,
                                "left": 34.42610062893082,
                                "width": 31.402066486972146,
                                "height": 17.699910152740337
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_IcoBrgR_e0YNAr5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm57440158",
                            "field1": "Mareblu",
                            "field2": "Tonno o.o.",
                            "field3": "Frigobox",
                            "field4": "gr. 80x7",
                            "description": "Mareblu Tonno o.o. Frigobox gr. 80x7",
                            "grammage": 560,
                            "price": "5.49",
                            "price_label": "€ 5,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 58.76010781671158,
                                "left": 65.31963162623539,
                                "width": 32.67340521114105,
                                "height": 17.699910152740337
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_ZLDxLrC_1xjaZXc.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm67681323",
                            "field1": "Freschello",
                            "field2": "Vino frizzante ",
                            "field3": "Bianco / Rosè",
                            "field4": "lt. 1",
                            "description": "Freschello Vino frizzante  Bianco / Rosè lt. 1",
                            "grammage": 1000,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Bianco",
                                "Rosè"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 76.01078167115902,
                                "left": 4.422506738544478,
                                "width": 30.384995507637008,
                                "height": 19.317160826594787
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_LdtpBTb_aMtMye4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm92515128",
                            "field1": "San benedetto",
                            "field2": "thè zero",
                            "field3": "vari gusti",
                            "field4": "cl.33",
                            "description": "San benedetto thè zero vari gusti cl.33",
                            "grammage": 330,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Limone",
                                "Pesca",
                                "Verde"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 75.65139263252469,
                                "left": 34.29896675651392,
                                "width": 31.783468104222813,
                                "height": 19.76639712488769
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_DfE6F83_zg3zfMJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm65381147",
                            "field1": "Pepsi",
                            "field2": "",
                            "field3": "lt. 1,5",
                            "field4": "",
                            "description": "Pepsi lt. 1,5",
                            "grammage": 1500,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 76.10062893081762,
                                "left": 65.44676549865225,
                                "width": 30.639263252470787,
                                "height": 19.40700808625337
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_is2jFtX_5hn68ms.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/piflsq6NHY/video/Pepsi__Global_Citizen__One_World_Together_At_Home_Artist_Lineup__15.mp4"
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 3,
                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/pages/page_3_D66v8ls.jpg",
                    "products": [
                        {
                            "item_id": "cstm91102557",
                            "field1": "Calvè",
                            "field2": "Maionese",
                            "field3": "",
                            "field4": "ml.500",
                            "description": "Calvè Maionese ml.500",
                            "grammage": 500,
                            "price": "1.19",
                            "price_label": "€ 1,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 4.222821203953279,
                                "left": 2.0069631626235447,
                                "width": 30.384995507637008,
                                "height": 18.508535489667562
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_Y5QaIKC_YRTTIPA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm89664128",
                            "field1": "Base pizza",
                            "field2": "Puccia x2",
                            "field3": "",
                            "field4": "gr.250",
                            "description": "Base pizza Puccia x2 gr.250",
                            "grammage": 250,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 4.132973944294698,
                                "left": 31.883423180592988,
                                "width": 31.9106019766397,
                                "height": 18.68823000898472
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_K8RvkJ2_S9m965l.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm19466292",
                            "field1": "Ortointavola",
                            "field2": "vaschette",
                            "field3": "",
                            "field4": "gr. 165/80",
                            "description": "Ortointavola vaschette gr. 165/80",
                            "grammage": null,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "gr. 165",
                                "gr.80"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 4.402515723270439,
                                "left": 63.28548966756514,
                                "width": 34.32614555256063,
                                "height": 18.418688230008982
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_5yGvoLi_jcsLxKR.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm10631386",
                            "field1": "Abram",
                            "field2": "speck",
                            "field3": "",
                            "field4": "",
                            "description": "Abram speck",
                            "grammage": null,
                            "price": "10.90",
                            "price_label": "€ 10,90 al Kg",
                            "equivalence": 10,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 25.426774483378253,
                                "left": 2.2612309074573274,
                                "width": 28.85938903863431,
                                "height": 14.465408805031444
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_eQezcfX_O2YqodT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm33652922",
                            "field1": "galbani",
                            "field2": "salame milano",
                            "field3": "",
                            "field4": "",
                            "description": "galbani salame milano",
                            "grammage": null,
                            "price": "8.99",
                            "price_label": "€ 8,99 al Kg",
                            "equivalence": 10,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 25.426774483378253,
                                "left": 31.756289308176097,
                                "width": 31.9106019766397,
                                "height": 14.465408805031444
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_mz0kogN_fbEVspm.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm43346407",
                            "field1": "Ferrarini",
                            "field2": "Prosciutto cotto",
                            "field3": "",
                            "field4": "",
                            "description": "Ferrarini Prosciutto cotto",
                            "grammage": null,
                            "price": "11.90",
                            "price_label": "€ 11,90 al Kg",
                            "equivalence": 10,
                            "quantity_step": 1,
                            "grocery_label": "etto/i",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 25.606469002695416,
                                "left": 63.03122192273135,
                                "width": 30.766397124887686,
                                "height": 14.106019766397123
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_wWIWInF_kkWeNE1.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm81899559",
                            "field1": "Vento di mare",
                            "field2": "fior di merluzzo",
                            "field3": "",
                            "field4": "gr.400",
                            "description": "Vento di mare fior di merluzzo gr.400",
                            "grammage": 400,
                            "price": "2.69",
                            "price_label": "€ 2,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 42.58760107816711,
                                "left": 2.134097035040436,
                                "width": 30.257861635220117,
                                "height": 14.465408805031444
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_tsyA9z8_9dndbOP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm91791805",
                            "field1": "San marco",
                            "field2": "vaschetta vari gusti",
                            "field3": "",
                            "field4": "gr.500",
                            "description": "San marco vaschetta vari gusti gr.500",
                            "grammage": 500,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Amarena",
                                "Caffè",
                                "Fiordilatte"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Dolci",
                            "blueprint": {
                                "top": 42.58760107816711,
                                "left": 31.62915543575921,
                                "width": 32.67340521114105,
                                "height": 14.465408805031444
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_6pWuuBl_RssbCux.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm55612962",
                            "field1": "dolfin",
                            "field2": "Sensofreddo",
                            "field3": "Granita, sorbetto e vari",
                            "field4": "Ml. 102x2",
                            "description": "dolfin Sensofreddo Granita, sorbetto e vari Ml. 102x2",
                            "grammage": 204,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Granita arancia rossa di Sicilia",
                                "Granita agrumi di Sicilia",
                                "Sorbetto mela verde"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Dolci",
                            "blueprint": {
                                "top": 40.07187780772685,
                                "left": 63.921159029649594,
                                "width": 29.240790655884993,
                                "height": 16.891284815813115
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_4G7kkYB_fZDWlxB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm64723946",
                            "field1": "Vidal",
                            "field2": "Bagnoschiuma",
                            "field3": "Vari tipi",
                            "field4": "ml.500",
                            "description": "Vidal Bagnoschiuma Vari tipi ml.500",
                            "grammage": 500,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Muschio bianco",
                                "Mora e muschio",
                                "Avena e latte di riso"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 59.02964959568732,
                                "left": 2.2612309074573274,
                                "width": 30.257861635220124,
                                "height": 17.250673854447435
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_NDEidoF_H8fp8d2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm92680555",
                            "field1": "Colgate",
                            "field2": "Dentifricio classico",
                            "field3": "",
                            "field4": "ml. 75+25",
                            "description": "Colgate Dentifricio classico ml. 75+25",
                            "grammage": 100,
                            "price": "0.85",
                            "price_label": "€ 0,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Orale",
                            "blueprint": {
                                "top": 59.02964959568732,
                                "left": 32.01055705300988,
                                "width": 32.0377358490566,
                                "height": 17.250673854447435
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_s3BvDDL_NLFvqqE.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm23363503",
                            "field1": "Morbidea",
                            "field2": "assorbenti",
                            "field3": "vari tipi",
                            "field4": "",
                            "description": "Morbidea assorbenti vari tipi",
                            "grammage": null,
                            "price": "0.85",
                            "price_label": "€ 0,85",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Giorno con ali",
                                "Giorno anatomico",
                                "Notte con ali"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Intima",
                            "blueprint": {
                                "top": 59.92812219227312,
                                "left": 63.53975741239891,
                                "width": 32.0377358490566,
                                "height": 16.352201257861633
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_3TFavAA_RIkkDzJ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm92338324",
                            "field1": "Dove deo",
                            "field2": "Roll on ",
                            "field3": "Original/ Melograno / For men invisible",
                            "field4": "ml. 50",
                            "description": "Dove deo Roll on  Original/ Melograno / For men invisible ml. 50",
                            "grammage": 50,
                            "price": "1.15",
                            "price_label": "€ 1,15",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Original",
                                "Melograno",
                                "For men invisible"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 75.92093441150044,
                                "left": 2.03414195867026,
                                "width": 30.51212938005391,
                                "height": 19.496855345911946
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_AVp8Zrd_gMDdMY3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm51577894",
                            "field1": "Dove deo",
                            "field2": "Spray ",
                            "field3": "vari tipi",
                            "field4": "ml. 150",
                            "description": "Dove deo Spray  vari tipi ml. 150",
                            "grammage": 150,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Original",
                                "Invisible dry",
                                "Clear confort"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 76.1006289308176,
                                "left": 31.910601976639708,
                                "width": 31.91060197663971,
                                "height": 19.496855345911946
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_Z7bdmhB_J5pNvw3.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm20952642",
                            "field1": "Intesa",
                            "field2": "deo spray ",
                            "field3": "Ambra / Guaranà",
                            "field4": "ml. 125",
                            "description": "Intesa deo spray  Ambra / Guaranà ml. 125",
                            "grammage": 125,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Ambra",
                                "Guaranà"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 76.01078167115902,
                                "left": 63.439802336028734,
                                "width": 31.91060197663971,
                                "height": 19.496855345911946
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_uwoTpVn_5SwF6PB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 4,
                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/pages/page_4_6izDlJi.jpg",
                    "products": [
                        {
                            "item_id": "cstm61881238",
                            "field1": "Morbidea",
                            "field2": "Pannolini",
                            "field3": "Varie misure",
                            "field4": "",
                            "description": "Morbidea Pannolini Varie misure",
                            "grammage": null,
                            "price": "2.59",
                            "price_label": "€ 2,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Prima infanzia",
                            "subcategory": "Puericultura",
                            "blueprint": {
                                "top": 4.269014759714142,
                                "left": 6.394878706199462,
                                "width": 31.14420485175202,
                                "height": 14.552716212826883
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_RdoCWNW_0IYzz1R.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm96492333",
                            "field1": "Huggies",
                            "field2": "Salviettine",
                            "field3": "",
                            "field4": "x56",
                            "description": "Huggies Salviettine x56",
                            "grammage": null,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Prima infanzia",
                            "subcategory": "Puericultura",
                            "blueprint": {
                                "top": 4.358862019372722,
                                "left": 37.54267744833783,
                                "width": 28.855795148247974,
                                "height": 14.552716212826883
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_3tJ6taj_LZXqDkv.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm28881284",
                            "field1": "Humana",
                            "field2": "Amorosa acqua",
                            "field3": "baby",
                            "field4": "lt.1",
                            "description": "Humana Amorosa acqua baby lt.1",
                            "grammage": 1000,
                            "price": "0.90",
                            "price_label": "€ 0,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Prima infanzia",
                            "subcategory": "Puericultura",
                            "blueprint": {
                                "top": 4.269014759714142,
                                "left": 66.14779874213833,
                                "width": 28.855795148247974,
                                "height": 14.552716212826883
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_CzdZPyv_Kdz3r4b.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm91183012",
                            "field1": "Fisiotherm",
                            "field2": "Gel igienizzante mani",
                            "field3": "",
                            "field4": "ml.300",
                            "description": "Fisiotherm Gel igienizzante mani ml.300",
                            "grammage": 300,
                            "price": "4.00",
                            "price_label": "€ 4,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 21.160299575527254,
                                "left": 6.356693620844563,
                                "width": 31.14420485175202,
                                "height": 14.552716212826883
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_OvUdM7N_ZAKGp32.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm03645181",
                            "field1": "wow",
                            "field2": "Carta igienica 4 rotoli",
                            "field3": "2 veli compatta",
                            "field4": "",
                            "description": "wow Carta igienica 4 rotoli 2 veli compatta",
                            "grammage": null,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 21.250146835185838,
                                "left": 37.8858939802336,
                                "width": 28.4743935309973,
                                "height": 14.552716212826883
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_8r4OYg5_foNT9DQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm23147485",
                            "field1": "ace",
                            "field2": "wc gel disincrostante",
                            "field3": "",
                            "field4": "ml.700",
                            "description": "ace wc gel disincrostante ml.700",
                            "grammage": 700,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 21.070452315868675,
                                "left": 66.9995507637017,
                                "width": 30.25426774483378,
                                "height": 14.552716212826883
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_toVGuQK_9H7d7uB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm09899178",
                            "field1": "soft",
                            "field2": "Polvere lavatrice",
                            "field3": "Classico / Lavanda",
                            "field4": "70+8 mis.",
                            "description": "soft Polvere lavatrice Classico / Lavanda 70+8 mis.",
                            "grammage": null,
                            "price": "3.65",
                            "price_label": "€ 3,65",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classico",
                                "Lavanda"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 35.6257083805587,
                                "left": 5.848158131177005,
                                "width": 31.77987421383647,
                                "height": 16.798897704291395
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_ZWUp2vh_W6RLzBs.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm80750074",
                            "field1": "ace",
                            "field2": "lavatrice liquido",
                            "field3": "vari tipi",
                            "field4": "25 misurini",
                            "description": "ace lavatrice liquido vari tipi 25 misurini",
                            "grammage": null,
                            "price": "2.39",
                            "price_label": "€ 2,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Colorati",
                                "Igienizzante"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 35.6257083805587,
                                "left": 37.63162623539982,
                                "width": 28.72866127583108,
                                "height": 16.619203184974236
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_oSWQgnv_vdJy1qG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm18053554",
                            "field1": "Smac express",
                            "field2": "Pavimenti",
                            "field3": "gialla",
                            "field4": "lt.1",
                            "description": "Smac express Pavimenti gialla lt.1",
                            "grammage": 1000,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Pavimenti",
                            "blueprint": {
                                "top": 35.805402899875865,
                                "left": 65.98247978436656,
                                "width": 31.398472596585798,
                                "height": 16.619203184974236
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_fnqd5wR_gFxOY4A.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm90037500",
                            "field1": "italflon",
                            "field2": "pentole ",
                            "field3": "varie tipologie",
                            "field4": "",
                            "description": "italflon pentole  varie tipologie",
                            "grammage": null,
                            "price": "2.59",
                            "price_label": "€ 2,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Piccoli elettrodomestici",
                            "subcategory": "Preparazione cibo",
                            "blueprint": {
                                "top": 52.11141060197664,
                                "left": 2.896900269541783,
                                "width": 34.961814914645096,
                                "height": 16.26235399820305
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_0GTJsVB_8t5i4N9.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm74001712",
                            "field1": "cerve",
                            "field2": "Bottiglia vetro",
                            "field3": "assortiti ",
                            "field4": "lt.1",
                            "description": "cerve Bottiglia vetro assortiti  lt.1",
                            "grammage": 1000,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 52.20125786163521,
                                "left": 37.73158131176999,
                                "width": 27.588050314465406,
                                "height": 16.08265947888589
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_aClFFUV_RIaaS8B.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm64351314",
                            "field1": "cerve",
                            "field2": "Vaso vetro con tappo",
                            "field3": "cannuccia assortita",
                            "field4": "450 cc",
                            "description": "cerve Vaso vetro con tappo cannuccia assortita 450 cc",
                            "grammage": 450,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 52.20125786163521,
                                "left": 55.27605570530098,
                                "width": 25.29964061096136,
                                "height": 16.08265947888589
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_5jytN12_JSsfrNY.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm33317473",
                            "field1": "cerve",
                            "field2": "Bicchieri acqua",
                            "field3": "vetro",
                            "field4": "6x250 cc",
                            "description": "cerve Bicchieri acqua vetro 6x250 cc",
                            "grammage": 1500,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 52.291105121293796,
                                "left": 79.94002695417788,
                                "width": 17.29020664869721,
                                "height": 16.08265947888589
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_P9iywG9_HLZSrcA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm64595948",
                            "field1": "Bama",
                            "field2": "contenitore",
                            "field3": "",
                            "field4": "40x60x29",
                            "description": "Bama contenitore 40x60x29",
                            "grammage": null,
                            "price": "4.99",
                            "price_label": "€ 4,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 68.2839173405211,
                                "left": 6.329514824797847,
                                "width": 31.14779874213836,
                                "height": 18.238993710691823
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_xE6GwjH_4caOIkO.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm37462560",
                            "field1": "Mercury",
                            "field2": "Scatole per armadi in tnt",
                            "field3": "",
                            "field4": "50x40",
                            "description": "Mercury Scatole per armadi in tnt 50x40",
                            "grammage": null,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 68.2839173405211,
                                "left": 37.73158131176999,
                                "width": 28.732255166217424,
                                "height": 17.699910152740337
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_6qUn4za_AVn6kwr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "cstm93240739",
                            "field1": "Borella",
                            "field2": "Scatola armadio extra",
                            "field3": "",
                            "field4": "50x40x25",
                            "description": "Borella Scatola armadio extra 50x40x25",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 68.37376460017968,
                                "left": 65.95530098831985,
                                "width": 31.147798742138367,
                                "height": 17.699910152740337
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/products/cropped_image_D4NWxI9_kA1bE0f.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 5,
                    "image_file": "https://interattivo.s3.amazonaws.com/piflsq6NHY/pages/indice_costantiello-02_DVvWqX2.png",
                    "products": []
                }
            ]
        }

    }

}

const lefletSwitch = () => {
    return leaflets.costantiello;
}

export const serverResponse = lefletSwitch();